var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNexticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 7.49978,
    cy: 6.99978,
    r: 6.49978,
    stroke: "#192126",
    strokeWidth: 0.966758,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M6.07813 3.95335C7.34729 5.22251 8.05885 5.93407 9.32801 7.20324L6.07812 10.4531",
    stroke: "#192126",
    strokeWidth: 0.966758,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexticon);
export default __webpack_public_path__ + "static/media/nexticon.98028f005ee509e7fc6a820ae142dded.svg";
export { ForwardRef as ReactComponent };